import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _FORM_FIELD_TYPES_COM, _FORM_FIELD_TYPES_VAL;
import React from 'react';
import { FORM_FIELD_TYPES } from '../../../DynamicForm.constants';
import CheckboxField from '../CheckboxField';
import { validateFormField as validateCheckboxField } from '../CheckboxField/CheckboxField.utils';
import InputField from '../InputField';
import { validateFormField as validateInputField } from '../InputField/InputField.utils';
import LocationSelect from '../LocationSelect/LocationSelect';
import { validateFormField as validateLocationSelectField } from '../LocationSelect/LocationSelect.utils';
import MarkdownText from '../MarkdownText';
import { validateMarkdownText } from '../MarkdownText/MarkdownText.utils';
import MultiSelectField from '../MultiSelectField';
import { validateFormField as validateMultiSelectField } from '../MultiSelectField/MultiSelectField.utils';
import SelectField from '../SelectField';
import { validateFormField as validateSelectField } from '../SelectField/SelectField.utils';
import UploadFileField from '../UploadFileField';
import { validateFormField as validateUploadCareField } from '../UploadFileField/UploadFileField.utils';
export var FORM_FIELD_TYPES_COMPONENT_MAP = (_FORM_FIELD_TYPES_COM = {}, _defineProperty(_FORM_FIELD_TYPES_COM, FORM_FIELD_TYPES.Input, function (props) {
  return /*#__PURE__*/React.createElement(InputField, props);
}), _defineProperty(_FORM_FIELD_TYPES_COM, FORM_FIELD_TYPES.Textarea, function (props) {
  return /*#__PURE__*/React.createElement(InputField, props);
}), _defineProperty(_FORM_FIELD_TYPES_COM, FORM_FIELD_TYPES.Select, function (props) {
  return /*#__PURE__*/React.createElement(SelectField, props);
}), _defineProperty(_FORM_FIELD_TYPES_COM, FORM_FIELD_TYPES.MultiSelect, function (props) {
  return /*#__PURE__*/React.createElement(MultiSelectField, props);
}), _defineProperty(_FORM_FIELD_TYPES_COM, FORM_FIELD_TYPES.FileUpload, function (props) {
  return /*#__PURE__*/React.createElement(UploadFileField, props);
}), _defineProperty(_FORM_FIELD_TYPES_COM, FORM_FIELD_TYPES.Checkbox, function (props) {
  return /*#__PURE__*/React.createElement(CheckboxField, props);
}), _defineProperty(_FORM_FIELD_TYPES_COM, FORM_FIELD_TYPES.LocationSelect, function (props) {
  return /*#__PURE__*/React.createElement(LocationSelect, props);
}), _defineProperty(_FORM_FIELD_TYPES_COM, FORM_FIELD_TYPES.MarkdownText, function (props) {
  return /*#__PURE__*/React.createElement(MarkdownText, props);
}), _FORM_FIELD_TYPES_COM);
export var FORM_FIELD_TYPES_VALIDATION_MAP = (_FORM_FIELD_TYPES_VAL = {}, _defineProperty(_FORM_FIELD_TYPES_VAL, FORM_FIELD_TYPES.Input, function (field, value) {
  return validateInputField(field, value);
}), _defineProperty(_FORM_FIELD_TYPES_VAL, FORM_FIELD_TYPES.Textarea, function (field, value) {
  return validateInputField(field, value);
}), _defineProperty(_FORM_FIELD_TYPES_VAL, FORM_FIELD_TYPES.Select, function (field, value) {
  return validateSelectField(field, value);
}), _defineProperty(_FORM_FIELD_TYPES_VAL, FORM_FIELD_TYPES.MultiSelect, function (field, value) {
  return validateMultiSelectField(field, value);
}), _defineProperty(_FORM_FIELD_TYPES_VAL, FORM_FIELD_TYPES.FileUpload, function (field, value) {
  return validateUploadCareField(field, value);
}), _defineProperty(_FORM_FIELD_TYPES_VAL, FORM_FIELD_TYPES.Checkbox, function (field, value) {
  return validateCheckboxField(field, value);
}), _defineProperty(_FORM_FIELD_TYPES_VAL, FORM_FIELD_TYPES.LocationSelect, function (field, value) {
  return validateLocationSelectField(field, value);
}), _defineProperty(_FORM_FIELD_TYPES_VAL, FORM_FIELD_TYPES.MarkdownText, function (field, value) {
  return validateMarkdownText(field, value);
}), _FORM_FIELD_TYPES_VAL);